import axios from 'axios';
import { startGlobalLoader, stopGlobalLoader } from '../utils/globalLoaderBus';

const GLOBAL_HOOK_KEY = '__skhoolGlobalAxiosLoaderBound';

const bindGlobalAxiosLoader = () => {
  if (typeof axios[GLOBAL_HOOK_KEY] === 'boolean' && axios[GLOBAL_HOOK_KEY]) {
    return;
  }

  axios.interceptors.request.use(
    (config) => {
      if (!config?.skipGlobalLoader) {
        config.__globalLoaderTracked = true;
        startGlobalLoader();
      }
      return config;
    },
    (error) => {
      if (error?.config?.__globalLoaderTracked) {
        stopGlobalLoader();
      }
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      if (response?.config?.__globalLoaderTracked) {
        stopGlobalLoader();
      }
      return response;
    },
    (error) => {
      if (error?.config?.__globalLoaderTracked) {
        stopGlobalLoader();
      }
      return Promise.reject(error);
    }
  );

  axios[GLOBAL_HOOK_KEY] = true;
};

bindGlobalAxiosLoader();

